// Wave 3.51 — EditedMarker
// Small inline marker (* in amber) shown next to values that were
// changed via an approved Edit Transaction Request.
//
// Usage:
//   <EditedMarker show={edited.carats} title="Edited via approved Edit Request" />
//
// Pair with ``EDITED_VALUE_CLASS`` (text-amber-600 font-medium) when you
// want the value itself to change color.

import React from 'react';

export function EditedMarker({ show, title = 'Edited via approved Edit Request' }) {
  if (!show) return null;
  return (
    <span
      className="ml-0.5 text-amber-600 font-bold"
      title={title}
      aria-label="edited"
      data-testid="edited-marker"
    >
      *
    </span>
  );
}

export default EditedMarker;
